"use strict";

var s;
symbol.length > 0 ? s = symbol :  s = "eurusd:cur";
//typeof symbol !== 'undefined' ? s = symbol :  s = "eurusd:cur";
currentSymbol = s;

/*******************************************USER CONFIG*******************************************/
function start (metaData){

	var symbolPeram = {"color":"#2962FF","axis":null,"type":defaultChartType,"yAxis":null}
	var myCdata = { "bs":s,
					"series":{
						'eurusd:cur':{
							"color":"#2962FF"
							,"axis":null
							,"type":defaultChartType
							,"yAxis":null}
						},
					"isIntraday":false
					,"unique":"monthly"
					,"interval":defaultChartInterval //default interval
					,"allow_interval":false
					,"agr":null
					,"tiny":null
					,"d1":null
					,"d2":null
					,"isPlus50": metaData.isPlus50
					,"isPlus25": metaData.isPlus25
					,"isPlus10": metaData.isPlus10
					,"isPlus5": metaData.isPlus5
					,"compareNumber": 1
					,"n":"300"
					,"eTitle":null
				};
		myCdata.bs = s ? s : "eurusd:cur";
		myCdata.mainSymbol = s ? s : "eurusd:cur";
		delete myCdata.series["eurusd:cur"];
		myCdata.series[s] = symbolPeram;

	var chart_obj = {
		themeConf: {
			colors: ["#2962FF", "#459a63", "#df9a63", "#059BAF", "#C86D80", "#df2d1c" ,"#8fb915" , "#525266"],
		},
		dataSource: 'teapi',
		cdata: myCdata,
		useStorage: false,
		live: true,
		menu: {
			style: 'top',
			type: true,
			interval: true,
			span: 'bottom',
			search: false,
			share: !true,
			axis: false,
			outSettings: true,
			zoomSettings: false,
			controlBar:true,
			headerLabels: true,
			animation:true,
			compareButton:true,
			bodyLabelsMoreSeries:true,
			bodyLabels:true,
			fullscreen: false,
			clock:false,
			enableOptions: true
		},
		chartOptions: {
			crosshairs: {
				enabled: true
			},
		},
		prefType: defaultChartType,
		events: {
			build: function (error, chart) {
				if (error) {
					console.error("CHART ERROR -> DIV SET TO INVISIBLE");
					$('#trading_chart').css("display", "none");
				}
			}
		}
	}

	//Plotting the chart
	new IeChart($('#trading_chart')[0], chart_obj);
}

$(document).ready(function() {
	if(isPakoLoaded) {
		checkMetaData();
	}else{
			$.getScript('https://d3fy651gv2fhd3.cloudfront.net/js/pako.js?v=20240223', function () {
				checkMetaData();
			});
	}
});

function checkMetaData() {

	var result;
	typeof TEChartsMeta !== 'undefined' ? result = TEChartsMeta :  result = [];
	var metaData= {isPlus50: true, isPlus25 : true, isPlus10 : true, isPlus5 : true};

		if(result[0] && result.length>0) {

			if(result[0].first_date) {
				
				var d1 = Date.now();
				var d2 = parseInt(result[0].first_date.split('(')[1].split(')')[0]);

				var diff = d1 -d2;
				var five_years = 5*365*24*60*60*1000;
				var ten_years = 10*365*24*60*60*1000;
				var tweFive_years = 25*365*24*60*60*1000;
				var fifty_years = 50*365*24*60*60*1000;

				if ( diff > fifty_years){
					metaData.isPlus50 = true;
					metaData.isPlus25 = true;
					metaData.isPlus10 = true;
					metaData.isPlus5 = true;
				}
				else if ( diff > tweFive_years) {
					metaData.isPlus50 = false;
					metaData.isPlus25 = true;
					metaData.isPlus10 = true;
					metaData.isPlus5 = true;
				}
				else if ( diff > ten_years) {
					metaData.isPlus50 = false;
					metaData.isPlus25 = false;
					metaData.isPlus10 = true;
					metaData.isPlus5 = true;
				}
				else if ( diff <= ten_years && diff > five_years) {
					metaData.isPlus50 = false;
					metaData.isPlus25 = false;
					metaData.isPlus10 = false;
					metaData.isPlus5 = true;
				}
				else if ( diff <= five_years) {
					metaData.isPlus50 = false;
					metaData.isPlus25 = false;
					metaData.isPlus10 = false;
					metaData.isPlus5 = false;
				}
			}

			if (result[0].default_interval) {
				var metaDefaultInterval = result[0].default_interval.toLowerCase();

				if (result[0].allowed_interval && forceIntraday != true) {
					allowed_interval = result[0].allowed_interval;
				}else{
					allowed_interval = '1m';
				}

				if (result[0].has_intraday == true && metaDefaultInterval != "1d" && metaDefaultInterval != "1h" && metaDefaultInterval != "4h") {

					defaultChartType = result[0].chart_type ? result[0].chart_type : "candlestick";
					defaultChartInterval = metaDefaultInterval;
					has_intraday = true;
					start(metaData);
				}
				else if (result[0].has_intraday == true && (metaDefaultInterval == "1d" || metaDefaultInterval == "4h" || metaDefaultInterval == "1h")) {

					var type = result[0].chart_type;
					if(result[0].chart_type == "line") {
						type = "line";
					}

					defaultChartType = result[0].chart_type ? type : "line";
					defaultChartInterval = metaDefaultInterval;
					has_intraday = true;
					start(metaData);
				}
				else {

					var type = result[0].chart_type;
					if(result[0].chart_type == "line") {
						type = "line";
					}

					defaultChartType = result[0].chart_type ? type : "line";
					defaultChartInterval = "1d";
					has_intraday = false;
					start(metaData);
				}
			} 
			else if (result[0].allowed_interval && result[0].has_intraday == true && metaDefaultInterval != "1d") {

				allowed_interval = result[0].allowed_interval;
				defaultChartType = "line";
				defaultChartInterval = "1d";
				has_intraday = true;
				start(metaData);
			} 
			else {

				allowed_interval = result[0].allowed_interval;

				var type = result[0].chart_type
				if(result[0].chart_type == "line") {
					type = "line";
				}

				defaultChartType = result[0].chart_type ? type : "line";
				defaultChartInterval = "1d";
				has_intraday = false;
				start(metaData);
			}
		}
		else {
			defaultChartInterval = "1d";
			defaultChartType = "line";
			start(metaData);
		}
}